<template>
  <nav class="navbar">
    <div class="nav-container">
      <div class="nav-logo">
        <router-link to="/">
          <!-- <img src="../assets/logotext.png" alt="logo" class="logo-image"> -->
          <!-- <img src="../assets/logotext-2.jpg" alt="logo" class="logo-imagetwo"> -->
          <img src="../assets/logotext-3.png" alt="logo" class="logo-imagethree logo-desktop">
          <img src="../assets/favicon.png" alt="logo" class="logo-imagethree logo-mobile">
        </router-link>
      </div>
      <div class="nav-menu">
        <router-link to="/" class="nav-link" exact>首页</router-link>
        
        <!-- 产品下拉菜单 -->
        <div class="nav-dropdown" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <span class="nav-link dropdown-trigger">
            产品
            <i class="dropdown-arrow" :class="{ 'arrow-up': showDropdown }"></i>
          </span>
          <transition name="dropdown-fade">
            <div class="dropdown-menu" v-show="showDropdown">
              <div class="dropdown-content">
                <div class="product-grid">
                  <div 
                    class="product-item" 
                    v-for="(product, index) in products" 
                    :key="index"
                    @click="handleProductClick(product)"
                  >
                    <div class="product-info">
                      <div class="product-title">{{ product.name }}</div>
                      <div class="product-desc">{{ product.desc }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        
        <router-link to="/about" class="nav-link">关于我们</router-link>
        <router-link to="/services" class="nav-link">服务内容</router-link>
        <router-link to="/join" class="nav-link">加入我们</router-link>
        <router-link to="/contact" class="nav-link">联系我们</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      showDropdown: false,
      products: [
        {
          name: '天浪知行助手',
          desc: '《天浪知行助手》是一款融合传统文化智慧与现代科技创新的智能命理分析平台。它帮助用户更好地了解自己，把握机遇，规避风险，实现人生的和谐发展。',
          link: '/zhixing'
        },
        {
          name: '视频管理系统',
          desc: '一款专业的PC端视频管理平台，支持视频上传、分类管理、数据统计分析等功能，助力企业高效管理视频资源。',
          link: '/video-system'
        },
        {
          name: '卡券商城',
          desc: '多商户卡券电商系统，支持卡券下发、用户绑定、小程序购物，平台端与商户端分离管理，助力企业打造卡券营销生态。',
          link: '/coupon-mall'
        }
      ]
    }
  },
  computed: {
    isJoinPage() {
      return this.$route.path === '/join';
    }
  },
  methods: {
    handleProductClick(product) {
      this.showDropdown = false;
      if (product.link) {
        // 在新标签页中打开
        const routeUrl = this.$router.resolve(product.link);
        window.open(routeUrl.href, '_blank');
      }
    }
  },
  mounted() {
    console.log('当前路由', this.$route.path);
  }
}
</script>

<style scoped lang="scss">
.logo-imagetwo{
  width: 80px;
  height: 80px;
}

.logo-imagethree{
  width: 150px;
  height: 100%;
}

.logo-desktop {
  display: block;
}

.logo-mobile {
  display: none;
}

.logo-image {
  width: 150px;
  height: 100%;
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  height: 80px;
  display: flex;
  align-items: center;
}

// 提高透明样式优先级
.navbar-transparent {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.nav-logo a {
  font-size: 20px;
  font-weight: bold;
  color: #1e3a8a;
  text-decoration: none;
  
  &:hover {
    color: #3498db;
  }
}

.nav-menu {
  display: flex;
  gap: 30px;
  align-items: center;
  
  .nav-link {
    color: #666;
    text-decoration: none;
    font-size: 15px;
    padding: 8px 0;
    transition: color 0.3s ease;
    cursor: pointer;
    
    &:hover {
      color: #1e3a8a;
    }
    
    // 使用 exact-active 确保只有完全匹配的路由才高亮
    &.router-link-exact-active {
      color: #1e3a8a;
      font-weight: bold;
    }
  }
}

// 产品下拉菜单
.nav-dropdown {
  position: relative;
  
  .dropdown-trigger {
    display: flex;
    align-items: center;
    gap: 4px;
    user-select: none;
    
    .dropdown-arrow {
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid #666;
      transition: transform 0.3s ease;
      margin-left: 2px;
      
      &.arrow-up {
        transform: rotate(180deg);
      }
    }
    
    &:hover {
      color: #1e3a8a;
      
      .dropdown-arrow {
        border-top-color: #1e3a8a;
      }
    }
  }
  
  .dropdown-menu {
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    padding-top: 0;
    z-index: 1001;
  }
  
  .dropdown-content {
    background: #fff;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    padding: 45px 0;
    border-top: 1px solid #ebeef5;
  }
  
  .product-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 28px 20px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 40px;
  }
  
  .product-item {
    padding: 18px 14px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background: #f5f7fa;
      
      .product-title {
        color: #409eff;
      }
    }
  }
  
  .product-info {
    flex: 1;
    min-width: 0;
  }
  
  .product-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 6px;
    white-space: nowrap;
    transition: color 0.3s ease;
  }
  
  .product-desc {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

// 下拉动画
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.25s ease;
}

.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 768px) {
  .nav-container {
    padding: 0 15px;
  }
  
  .logo-desktop {
    display: none;
  }
  
  .logo-mobile {
    display: block;
    width: 100px;
  }
  
  .nav-logo a {
    font-size: 18px;
  }
  
  .nav-menu {
    gap: 20px;
    
    .nav-link {
      font-size: 20px;
    }
  }
  
  .nav-dropdown {
    .dropdown-menu {
      top: 70px;
    }
    
    .dropdown-content {
      padding: 20px 0;
    }
    
    .product-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
      padding: 0 20px;
    }
    
    .product-item {
      padding: 10px;
    }
    
    .product-title {
      font-size: 13px;
    }
    
    .product-desc {
      font-size: 11px;
      -webkit-line-clamp: 1;
    }
  }
}

@media (max-width: 600px) {
  .navbar {
    height: 70px;
  }
  
  .nav-container {
    padding: 0 12px;
  }
  
  .logo-mobile {
    width: 65px; /* 手机版logo尺寸调小 */
  }
  
  .nav-menu {
    gap: 16px;
    
    .nav-link {
      font-size: 17px; /* 进一步增大导航文字 */
      padding: 6px 0;
    }
  }
  
  .nav-dropdown {
    .dropdown-menu {
      top: 70px;
    }
    
    .product-grid {
      grid-template-columns: 1fr;
      gap: 8px;
      padding: 0 15px;
    }
    
    .product-item {
      padding: 8px;
    }
    
    .dropdown-trigger .dropdown-arrow {
      border-left-width: 4px;
      border-right-width: 4px;
      border-top-width: 4px;
    }
  }
}

@media (max-width: 480px) {
  .navbar {
    height: 65px;
  }
  
  .nav-container {
    padding: 0 10px;
  }
  
  .logo-mobile {
    width: 55px; /* 手机版logo尺寸调小 */
  }
  
  .nav-menu {
    gap: 12px;
    
    .nav-link {
      font-size: 14px; /* 进一步增大导航文字 */
      padding: 5px 0;
    }
  }
}

@media (max-width: 360px) {
  .navbar {
    height: 60px;
  }
  
  .nav-container {
    padding: 0 8px;
  }
  
  .logo-mobile {
    width: 50px; /* 手机版logo尺寸调小 */
  }
  
  .nav-menu {
    gap: 10px;
    
    .nav-link {
      font-size: 12px; /* 进一步增大导航文字 */
      padding: 4px 0;
    }
  }
}
</style> 